import './Auth.scss';
import Component from './Auth.js';
export default Component;
